// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '../../../../entity/Entity';

const BodyConfirm = ({ confirmationMessage, namespace }) => {
    return (
        <div className='text-justify my-4'>
            <Entity namespace={namespace} className='font-normal' entity={confirmationMessage} />
        </div>
    );
};

BodyConfirm.propTypes = {
    confirmationMessage: PropTypes.string.isRequired,
    namespace: PropTypes.string.isRequired
};

export default BodyConfirm;